import { generateSecretToken } from "@gymlog/shared";

const ALIAS_STORAGE_KEY = "gymlog_account_aliases";

type AliasMap = Record<string, string>;

function readAliasMap(): AliasMap {
  try {
    const raw = globalThis.localStorage.getItem(ALIAS_STORAGE_KEY);
    if (!raw) {
      return {};
    }
    const parsed: unknown = JSON.parse(raw);
    if (typeof parsed !== "object" || parsed === null || Array.isArray(parsed)) {
      return {};
    }
    const map: AliasMap = {};
    for (const [alias, userId] of Object.entries(parsed)) {
      if (
        typeof alias === "string" &&
        typeof userId === "string" &&
        alias !== "" &&
        userId !== ""
      ) {
        map[alias] = userId;
      }
    }
    return map;
  } catch {
    return {};
  }
}

function writeAliasMap(map: AliasMap): void {
  try {
    globalThis.localStorage.setItem(ALIAS_STORAGE_KEY, JSON.stringify(map));
  } catch {
    // Storage unavailable
  }
}

function mintAlias(): string {
  return generateSecretToken();
}

export function aliasForAccount(userId: string): string {
  const map = readAliasMap();
  for (const [alias, id] of Object.entries(map)) {
    if (id === userId) {
      return alias;
    }
  }
  const alias = mintAlias();
  map[alias] = userId;
  writeAliasMap(map);
  return alias;
}

export function accountIdForAlias(alias: string): string | null {
  return readAliasMap()[alias] ?? null;
}

export function pruneAliases(knownUserIds: readonly string[]): void {
  const map = readAliasMap();
  const known = new Set(knownUserIds);
  let changed = false;
  for (const [alias, userId] of Object.entries(map)) {
    if (!known.has(userId)) {
      delete map[alias];
      changed = true;
    }
  }
  if (changed) {
    writeAliasMap(map);
  }
}
